<div class="main-wrapper d-flex flex-column min-vh-100">
  <ngx-particles id="tsparticles" [options]="particlesOptions"></ngx-particles>
  <div id="main-content" [class.auth-route-active]="isAuthRoute">
    <app-main></app-main>
  </div>
</div>
